<!-- <button (click)="signOut()" style="background-image: url('assets/img/logout.svg'); background-size: contain;" class="cesium-button cesium-toolbar-button" title="Sign Out"></button> -->

<div class="modal-body text-center p-4">
  <div class="mb-3">
    <span style="font-size:2rem; color:#ff9800;">
      <i class="fa fa-exclamation-triangle"></i>
    </span>
  </div>
  <h3 class="mb-3" style="color:#e57373; font-weight:600;">
    Confirm Logout
  </h3>
  <div class="mb-4">
    Are you sure you want to sign out?
  </div>
  <div class="d-flex justify-content-center gap-2">
    <button type="button" class="btn btn-outline-secondary px-4" (click)="close(false)">No</button>
    <button type="button" class="btn btn-primary px-4" (click)="close(true)">Yes</button>
  </div>
</div>